import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const subscriptionsRenewalsDueWidget: DashboardWidgetConfiguration = {
  widgetId: "subscriptions.renewals-due",
  name: "Renewals due",
  description: "Renewals due for the selected dashboard period.",
  apps: [
    "subscriptions",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "subscriptions.renewals",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "record_id",
          as: "value",
        },
      ],
      where: {
        type: "condition",
        field: "status",
        operator: "in",
        value: [
          "pending",
          "due",
        ],
      },
    },
  },
  inputs: {
    label: "Renewals due",
    subtext: "in the last 30 days",
    icon: "calendar",
    color: "warning",
    valueFormat: "number",
    valueMultiplier: 1,
  },
  dummyData: {
    value: 18,
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
